import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { hideDataGridDialog } from "../../store/slice/dialogSlice";

const DataGridDialog = () => {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(hideDataGridDialog());
  };
  const open = useSelector((state) => state.dialogSlice.dataGridDialog);
  const url = useLocation().pathname;


  let content, action;

  switch (url) {
    // Evaluation form
    case "/evaluation-form":
      break;

  
    default:
      content = null;
      break;
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Grid </DialogTitle>
        <Divider />
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{color: 'gray', borderColor: '#D3D3D3'}}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DataGridDialog;
